<template>
  <BaseTable :name='name' :getDataAction='getDataAction' :tableColumns='tableColumns' :isShowCloseBtn='isShowCloseBtn' @SizeChange='sizeChange' @StateChange='stateChange'></BaseTable>
</template>


<script>
import {
  GetOutRangeStocks
} from '@/api'
import BaseTable from './../baseTable.vue'

export default ({
  components: {
    BaseTable
  },
  data () {
    return {
      getDataAction: GetOutRangeStocks,
      tableColumns: [
        {
          no: 'no',
          name: '编码',
          width: 100,
          type: 'text'
        },
        {
          no: 'productName',
          name: '产品名称',
          width: 100,
          type: 'text',
        },
        {
          no: 'specName',
          name: '规格型号',
          width: 100,
          type: 'text',
        },
        {
          no: 'manufacturerName',
          name: '生产厂家',
          width: 100,
          type: 'text',
        },
        {
          no: 'maxNumber',
          name: '库存上限',
          width: 80,
          type: 'text',
        },
        {
          no: 'minNumber',
          name: '库存下限',
          width: 80,
          type: 'text',
        },
        {
          no: 'stockQuantity',
          name: '实时库存',
          width: 100,
          type: 'text',
        },

      ],
    };
  },
  props: {
    name: {
      type: String,
      default () {
        return ''
      }
    },
    isShowCloseBtn: {
      type: Boolean,
      default () {
        return true
      }
    }
  },
  //监听beforinfo值的变化
  watch: {
  },
  methods: {

    sizeChange (a, b, c, d) {
      this.$emit('SizeChange', a, b, c, d)
    },
    stateChange (a, b) {
      this.$emit('StateChange', a, b)
    },
  },
  mounted () {
  },
  /** 生命周期 - 创建完成（可以访问当前this实例） */
  created () {
  },
  beforeDestroy () {
  },
})
</script>
<style scoped lang="scss">
</style>
